import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {catchError, EMPTY, map, of, switchMap} from "rxjs";
import {
  addEditingRowsData,
  createCategoryData,
  deleteCategoryData,
  fetchCategoriesData, removeEditingRowsData,
  updateCategoriesData,
  updateCategoryData,
} from "./categories.action";
import {ContactApiService} from "../../services/contact-api.service";
import {SnackbarService} from "../../services/snackbar.service";
import {Store} from "@ngrx/store";

@Injectable()
export class CategoriesEffects {
  constructor(private actions$: Actions, private store: Store, private contactsAPI: ContactApiService, private snackbarService: SnackbarService ) {}

  fetchCategoriesData$ = createEffect(() => this.actions$.pipe(
    ofType(fetchCategoriesData),
    switchMap(() =>
      this.contactsAPI.fetchCategoriesData().pipe(
        map((categoriesData) => updateCategoriesData({categoriesData})),
        catchError(() => EMPTY)
      ))
  ))

  createCategoryData$ = createEffect(() => this.actions$.pipe(
    ofType(createCategoryData),
    switchMap((props =>
        this.contactsAPI.createCategoryData(props.category).pipe(
          map(() => {
            this.snackbarService.showSuccess("Kategori sparad!");
            this.store.dispatch(removeEditingRowsData({rowId: props.id}))
            return fetchCategoriesData();
          }),
          catchError(() => {
            this.snackbarService.showError("Misslyckades skapa kategori");
            return of(fetchCategoriesData());
          })
        )
    ))))

  updateCategoryData$ = createEffect(() => this.actions$.pipe(
    ofType(updateCategoryData),
    switchMap((props =>
      this.contactsAPI.updateCategoryData(props.category).pipe(
        map(() => {
          this.snackbarService.showSuccess("Kategori uppdaterad!");
          this.store.dispatch(removeEditingRowsData({rowId: props.category.id!}))
          return fetchCategoriesData();
        }),
        catchError(() => {
          this.snackbarService.showError("Misslyckades uppdatera kategori");

          if (props.saveMethod === "Regular") {
            // When dropping we do not want to enable edit mode. Only when doing a failed "edit"-save
            this.store.dispatch(addEditingRowsData({rowId: props.category.id!}))
            return EMPTY;
          }

          // When a drop fails to save we do not want to be in edit mode,
          // fetch all data again to send the row back to original placement
          this.store.dispatch(removeEditingRowsData({rowId: props.category.id!}))
          return of(fetchCategoriesData());
        })
      ))
    )))

  deleteCategoryData$ = createEffect(() => this.actions$.pipe(
    ofType(deleteCategoryData),
    switchMap((props =>
        this.contactsAPI.deleteCategoryData(props.categoryId).pipe(
          map(() => {
            this.snackbarService.showSuccess("Kategori raderad!");
            return fetchCategoriesData();
          }),
          catchError(() => {
            this.snackbarService.showError("Misslyckades radera kategori");
            return of(fetchCategoriesData());
          })
        )
    ))))
}
